/**
 * 从 Supabase User 上尽量解析出可用于展示/本地持久化的邮箱。
 * 部分登录方式下 `user.email` 可能暂时为空，但 metadata / identities 里仍有邮箱。
 */
export function resolveAuthEmail(user: unknown): string {
  if (!user || typeof user !== 'object') return '';
  const u = user as {
    email?: string | null;
    new_email?: string | null;
    user_metadata?: Record<string, unknown>;
    identities?: Array<{ identity_data?: { email?: string } }>;
  };
  const tryEmail = (v: unknown) => {
    if (typeof v !== 'string') return '';
    const t = v.trim();
    return t.includes('@') ? t : '';
  };
  const direct = tryEmail(u.email) || tryEmail(u.new_email);
  if (direct) return direct;
  const meta = u.user_metadata;
  if (meta && typeof meta === 'object') {
    const m = tryEmail(meta.email) || tryEmail(meta.preferred_username);
    if (m) return m;
  }
  const ids = u.identities;
  if (Array.isArray(ids)) {
    for (const row of ids) {
      const e = tryEmail(row?.identity_data?.email);
      if (e) return e;
    }
  }
  return '';
}
